// import axios from "axios"
// import { post, del, get, put } from "./api_helper"
// import * as url from "./url_helper"



// export const batchDetailFile = () => {
//   const authUser = JSON.parse(localStorage.getItem("authUser"));
//   const organizationId = authUser?.organizationId;
  
//   return axios.get(url.DOWNLOAD_BATCH_DETAILS_FILE, {
//     responseType: "blob",
//     headers: {
//       'X-Organization-ID': organizationId || ''
//     }
//   });
// };




// // export const batchDetailFile = () =>
// //   axios.get(url.DOWNLOAD_BATCH_DETAILS_FILE, {
// //     responseType: "blob",
// //   });

// // Create Class
// export const createBatch = data => post(url.CREATE_BATCH, data);
// export const updateBatch = data => put(url.UPDATE_BATCH, data);
// export const deleteBatch = id => del(url.DELETE_BATCH + id);
// export const fetchAllBatch = () => get(url.FETCH_ALL_BATCHES);
// export const fetchAllBatchOfTrainer = () => get(url.FETCH_ALL_BATCHES_OF_TRAINER);
// export const fetchSingleBatch = id => get(url.FETCH_SINGLE_BATCH + id);

// export const addImages = data => post(url.ADD_IMAGES + data.id, data.images);
// export const downloadImagesZipFile = id => get(url.DOWNLOAD_IMAGES_ZIP_FILE + id);
// export const deleteImageFromS3 = data => post(url.DELETE_IMAGE_FROM_S3, data);
// export const addCourseToBatch = ids => post(url.ADD_COURSE_TO_BATCH + ids);
// export const getAllCourseOfBatch = id => get(url.FETCH_ALL_COURSE_OF_BATCH + id);
// export const removeCourseFromBatch = ids => del(url.REMOVE_COURSE_FROM_BATCH + ids);

// // export const  batchDetailFile = ids => get(url + DOWNLOAD_BATCH_DETAILS_FILE + ids);
// export const addScormCourseToBatch = ids => post(url.ADD_SCORM_COURSE_TO_BATCH + ids);
// export const getAllScormCourseOfBatch = id => get(url.FETCH_ALL_SCORM_COURSE_OF_BATCH + id);
// export const removeScormCourseFromBatch = ids => del(url.REMOVE_SCORM_COURSE_FROM_BATCH + ids);

// export const addStudentToBatch = ids => post(url.ADD_STUDENT_TO_BATCH + ids);
// // export const addMultipleStudentsToBatch = id => get(url.ADD_MULTIPLE_STUDENTS_TO_BATCH.replace('{batchId}', id));
// export const removeStudentFromBatch = ids => del(url.REMOVE_STUDENT_FROM_BATCH + ids);
// export const getAllStudentOfBatch = id => get(url.FETCH_ALL_STUDENT_OF_BATCH + id);
// export const removeAllStudentsFromBatch = id => del(url.REMOVE_ALL_STUDENT_FROM_BATCH + id);

// export const addTrainerToBatch = ids => post(url.ADD_TRAINER_TO_BATCH + ids);
// export const removeTrainerFromBatch = ids => del(url.REMOVE_TRAINER_FROM_BATCH + ids);
// export const getAllTrainerOfBatch = id => get(url.FETCH_ALL_TRAINER_OF_BATCH + id);
// export const getAssessmentResultOfBatchStudent = ids => get(url.GET_ASSESSMENT_RESULT_OF_BATCH_STUDENT + ids);
// export const removeAllTrainersFromBatch = id => del(url.REMOVE_ALL_TRAINER_FROM_BATCH + id);

// export const updateProgress = ids => get(url.UPDATE_PROGRESS + ids);
// export const getStudentProgress = ids => get(url.GET_STUDENT_PROGRESS + ids);

// export const createLiveClass = data => post(url.CREATE_LIVE_CLASS, data);
// export const updateLiveClass = data => put(url.UPDATE_LIVE_CLASS, data);
// export const deleteLiveClass = id => del(url.DELETE_LIVE_CLASS + id);


// export const studentAddedNotification = id => get(url.STUDENT_ADDED_NOTIFICATION + id);
// export const trainingCompletionNotification = id => get(url.TRAINING_COMPLETION_NOTIFICATION + id);







// export const addMultipleStudentsToBatch = (batchId, studentIds, organizationId) => {
//   const studentIdsParam = studentIds.join(',');
//   const urlWithParams = `${url.ADD_MULTIPLE_STUDENTS_TO_BATCH.replace('{batchId}', batchId)}?studentIds=${studentIdsParam}`;
  
//   if (organizationId) {
//     return get(`${urlWithParams}&organizationId=${organizationId}`);
//   }
//   return get(urlWithParams);

  
// };



// Make sure these functions are properly implemented in your batch_helper.js

// // Create live class
// export const createLiveClass = async (data) => {
//     try {
//         const response = await axios.post(url + 'api/liveclass/create', data, {
//             headers: { 'Content-Type': 'application/json' }
//         });
//         return response.data;
//     } catch (error) {
//         console.error("Error creating live class:", error);
//         throw error;
//     }
// };


// // Update live class
// export const updateLiveClass = async (data) => {
//     try {
//         const response = await axios.put(url + 'api/liveclass/update', data, {
//             headers: { 'Content-Type': 'application/json' }
//         });
//         return response.data;
//     } catch (error) {
//         console.error("Error updating live class:", error);
//         throw error;
//     }
// };

// // Delete live class
// export const deleteLiveClass = async (id) => {
//     try {
//         const response = await axios.delete(url + 'api/liveclass/delete/' + id);
//         return response.data;
//     } catch (error) {
//         console.error("Error deleting live class:", error);
//         throw error;
//     }
//};




// with date range filter :






// import axios from "axios";
// import { post, del, get, put } from "./api_helper";
// import * as url from "./url_helper";
// import moment from "moment";

// // ============================
// // BATCH DETAILS EXCEL DOWNLOAD WITH DATE RANGE
// // ============================
// export const batchDetailFile = (startDate = null, endDate = null) => {
//   const authUser = JSON.parse(localStorage.getItem("authUser"));
//   const organizationId = authUser?.organizationId;
  
//   let apiUrl = url.DOWNLOAD_BATCH_DETAILS_FILE_WITH_FILTER;
//   const params = new URLSearchParams();
  
//   // Format dates to YYYY-MM-DD for backend
//   if (startDate) {
//     const formattedStart = moment(startDate).format("YYYY-MM-DD");
//     params.append("startDate", formattedStart);
//   }
//   if (endDate) {
//     const formattedEnd = moment(endDate).format("YYYY-MM-DD");
//     params.append("endDate", formattedEnd);
//   }
  
//   if (params.toString()) {
//     apiUrl += "?" + params.toString();
//   }
  
//   return axios.get(apiUrl, {
//     responseType: "blob",
//     headers: {
//       'X-Organization-ID': organizationId || ''
//     }
//   });
// };

// // ============================
// // GET ALL BATCHES WITH PAGINATION AND FILTERS
// // ============================
// export const fetchAllBatchesWithPagination = (page = 0, size = 10, startDate = null, endDate = null, state = null, depot = null, search = null) => {
//   const authUser = JSON.parse(localStorage.getItem("authUser"));
//   const organizationId = authUser?.organizationId;
  
//   let apiUrl = url.FETCH_ALL_BATCHES;
//   const params = new URLSearchParams();
//   params.append("page", page);
//   params.append("size", size);
//   if (startDate) params.append("startDate", startDate);
//   if (endDate) params.append("endDate", endDate);
//   if (state) params.append("state", state);
//   if (depot) params.append("depot", depot);
//   if (search) params.append("search", search);
  
//   apiUrl += "?" + params.toString();
  
//   return axios.get(apiUrl, {
//     headers: {
//       'X-Organization-ID': organizationId || ''
//     }
//   });
// };





// // ============================
// // OTHER EXISTING FUNCTIONS
// // ============================

// // Create Class
// export const createBatch = data => post(url.CREATE_BATCH, data);
// export const updateBatch = data => put(url.UPDATE_BATCH, data);
// export const deleteBatch = id => del(url.DELETE_BATCH + id);
// export const fetchAllBatch = () => get(url.FETCH_ALL_BATCHES);
// export const fetchAllBatchOfTrainer = () => get(url.FETCH_ALL_BATCHES_OF_TRAINER);
// export const fetchSingleBatch = id => get(url.FETCH_SINGLE_BATCH + id);

// export const addImages = data => post(url.ADD_IMAGES + data.id, data.images);
// export const downloadImagesZipFile = id => get(url.DOWNLOAD_IMAGES_ZIP_FILE + id);
// export const deleteImageFromS3 = data => post(url.DELETE_IMAGE_FROM_S3, data);
// export const addCourseToBatch = ids => post(url.ADD_COURSE_TO_BATCH + ids);
// export const getAllCourseOfBatch = id => get(url.FETCH_ALL_COURSE_OF_BATCH + id);
// export const removeCourseFromBatch = ids => del(url.REMOVE_COURSE_FROM_BATCH + ids);

// export const addScormCourseToBatch = ids => post(url.ADD_SCORM_COURSE_TO_BATCH + ids);
// export const getAllScormCourseOfBatch = id => get(url.FETCH_ALL_SCORM_COURSE_OF_BATCH + id);
// export const removeScormCourseFromBatch = ids => del(url.REMOVE_SCORM_COURSE_FROM_BATCH + ids);

// export const addStudentToBatch = ids => post(url.ADD_STUDENT_TO_BATCH + ids);
// export const removeStudentFromBatch = ids => del(url.REMOVE_STUDENT_FROM_BATCH + ids);
// export const getAllStudentOfBatch = id => get(url.FETCH_ALL_STUDENT_OF_BATCH + id);
// export const removeAllStudentsFromBatch = id => del(url.REMOVE_ALL_STUDENT_FROM_BATCH + id);

// export const addTrainerToBatch = ids => post(url.ADD_TRAINER_TO_BATCH + ids);
// export const removeTrainerFromBatch = ids => del(url.REMOVE_TRAINER_FROM_BATCH + ids);
// export const getAllTrainerOfBatch = id => get(url.FETCH_ALL_TRAINER_OF_BATCH + id);
// export const getAssessmentResultOfBatchStudent = ids => get(url.GET_ASSESSMENT_RESULT_OF_BATCH_STUDENT + ids);
// export const removeAllTrainersFromBatch = id => del(url.REMOVE_ALL_TRAINER_FROM_BATCH + id);

// export const updateProgress = ids => get(url.UPDATE_PROGRESS + ids);
// export const getStudentProgress = ids => get(url.GET_STUDENT_PROGRESS + ids);

// export const createLiveClass = data => post(url.CREATE_LIVE_CLASS, data);
// export const updateLiveClass = data => put(url.UPDATE_LIVE_CLASS, data);
// export const deleteLiveClass = id => del(url.DELETE_LIVE_CLASS + id);

// export const studentAddedNotification = id => get(url.STUDENT_ADDED_NOTIFICATION + id);
// export const trainingCompletionNotification = id => get(url.TRAINING_COMPLETION_NOTIFICATION + id);

// export const addMultipleStudentsToBatch = (batchId, studentIds, organizationId) => {
//   const studentIdsParam = studentIds.join(',');
//   const urlWithParams = `${url.ADD_MULTIPLE_STUDENTS_TO_BATCH.replace('{batchId}', batchId)}?studentIds=${studentIdsParam}`;
  
//   if (organizationId) {
//     return get(`${urlWithParams}&organizationId=${organizationId}`);
//   }
//   return get(urlWithParams);
// };









// batch_helper.js - Complete file with all exports

// batch_helper.js - Complete file with all exports

import axios from "axios";
import { post, del, get, put } from "./api_helper";
import * as url from "./url_helper";
import moment from "moment";

// ============================
// GET DISTINCT STATES AND DEPOTS
// ============================
export const getDistinctStates = () => {
  const authUser = JSON.parse(localStorage.getItem("authUser"));
  const organizationId = authUser?.organizationId;
  
  return axios.get(url.FETCH_DISTINCT_STATES, {
    headers: {
      'X-Organization-ID': organizationId || ''
    }
  });
};

export const getDistinctDepots = () => {
  const authUser = JSON.parse(localStorage.getItem("authUser"));
  const organizationId = authUser?.organizationId;
  
  return axios.get(url.FETCH_DISTINCT_DEPOTS, {
    headers: {
      'X-Organization-ID': organizationId || ''
    }
  });
};

// ============================
// FETCH ALL BATCHES WITH FILTERS (NO PAGINATION)
// ============================
export const fetchAllBatchesWithFilters = (
  startDate = null,
  endDate = null,
  state = null,
  depot = null,
  search = null,
  department = null,
  trainerName = null,
  batchType = null
) => {
  const authUser = JSON.parse(localStorage.getItem("authUser"));
  const organizationId = authUser?.organizationId;
  
  let apiUrl = url.FETCH_ALL_BATCHES;
  const params = new URLSearchParams();
  
  // Add pagination params to get all records
  params.append("page", 0);
  params.append("size", 10000); // Large number to get all
  
  if (startDate) params.append("startDate", startDate);
  if (endDate) params.append("endDate", endDate);
  if (state && state !== "") params.append("state", state);
  if (depot && depot !== "") params.append("depot", depot);
  if (search && search !== "") params.append("search", search);
  if (department && department !== "") params.append("department", department);
  if (trainerName && trainerName !== "") params.append("trainerName", trainerName);
  if (batchType && batchType !== "") params.append("batchType", batchType);
  
  apiUrl += "?" + params.toString();
  
  return axios.get(apiUrl, {
    headers: {
      'X-Organization-ID': organizationId || ''
    }
  });
};

// ============================
// BATCH DETAILS EXCEL DOWNLOAD WITH FULL FILTERS
// ============================
export const batchDetailFileWithFullFilters = (
  startDate = null, 
  endDate = null, 
  state = null, 
  depot = null, 
  search = null
) => {
  const authUser = JSON.parse(localStorage.getItem("authUser"));
  const organizationId = authUser?.organizationId;
  
  let apiUrl = url.DOWNLOAD_BATCH_DETAILS_FILE_WITH_FULL_FILTERS;
  const params = new URLSearchParams();
  
  if (startDate) {
    const formattedStart = moment(startDate).format("YYYY-MM-DD");
    params.append("startDate", formattedStart);
  }
  if (endDate) {
    const formattedEnd = moment(endDate).format("YYYY-MM-DD");
    params.append("endDate", formattedEnd);
  }
  if (state && state !== "") params.append("state", state);
  if (depot && depot !== "") params.append("depot", depot);
  if (search && search !== "") params.append("search", search);
  
  if (params.toString()) {
    apiUrl += "?" + params.toString();
  }
  
  return axios.get(apiUrl, {
    responseType: "blob",
    headers: {
      'X-Organization-ID': organizationId || ''
    }
  });
};

// ============================
// CONSOLIDATED SIMULATOR REPORT WITH FULL FILTERS
// ============================
// batch_helper.js - Fixed downloadConsolidatedSimulatorReport

export const downloadConsolidatedSimulatorReport = (
  startDate = null,
  endDate = null,
  state = null,
  depot = null,
  search = null,
  department = null,
  trainerName = null,
  batchType = null
) => {
  const authUser = JSON.parse(localStorage.getItem("authUser"));
  const organizationId = authUser?.organizationId;
  
  // Use the correct URL with /api prefix
  const baseUrl = process.env.REACT_APP_BASE_URL || "http://localhost:8080/api/";
  let apiUrl = `${baseUrl}simulator/consolidated-report`;
  
  const params = new URLSearchParams();
  
  if (startDate) {
    params.append("startDate", moment(startDate).format("YYYY-MM-DD"));
  }
  if (endDate) {
    params.append("endDate", moment(endDate).format("YYYY-MM-DD"));
  }
  if (state && state !== "") params.append("state", state);
  if (depot && depot !== "") params.append("depot", depot);
  if (search && search !== "") params.append("search", search);
  if (department && department !== "") params.append("department", department);
  if (trainerName && trainerName !== "") params.append("trainerName", trainerName);
  if (batchType && batchType !== "") params.append("batchType", batchType);
  
  if (params.toString()) {
    apiUrl += "?" + params.toString();
  }
  
  console.log("Downloading consolidated simulator report from:", apiUrl);
  
  return axios.get(apiUrl, {
    responseType: "blob",
    timeout: 600000,
    headers: {
      'X-Organization-ID': organizationId || ''
    }
  });
};
// ============================
// BATCH DETAILS EXCEL DOWNLOAD WITH DATE RANGE (LEGACY)
// ============================
export const batchDetailFile = (startDate = null, endDate = null) => {
  const authUser = JSON.parse(localStorage.getItem("authUser"));
  const organizationId = authUser?.organizationId;
  
  let apiUrl = url.DOWNLOAD_BATCH_DETAILS_FILE_WITH_FILTER;
  const params = new URLSearchParams();
  
  if (startDate) {
    const formattedStart = moment(startDate).format("YYYY-MM-DD");
    params.append("startDate", formattedStart);
  }
  if (endDate) {
    const formattedEnd = moment(endDate).format("YYYY-MM-DD");
    params.append("endDate", formattedEnd);
  }
  
  if (params.toString()) {
    apiUrl += "?" + params.toString();
  }
  
  return axios.get(apiUrl, {
    responseType: "blob",
    headers: {
      'X-Organization-ID': organizationId || ''
    }
  });
};

// ============================
// GET ALL BATCHES WITH PAGINATION AND FILTERS
// ============================
// export const fetchAllBatchesWithPagination = (
//   page = 0, 
//   size = 10, 
//   startDate = null, 
//   endDate = null, 
//   state = null, 
//   depot = null, 
//   search = null
// ) => {
//   const authUser = JSON.parse(localStorage.getItem("authUser"));
//   const organizationId = authUser?.organizationId;
  
//   let apiUrl = url.FETCH_ALL_BATCHES;
//   const params = new URLSearchParams();
//   params.append("page", page);
//   params.append("size", size);
//   if (startDate) params.append("startDate", startDate);
//   if (endDate) params.append("endDate", endDate);
//   if (state && state !== "") params.append("state", state);
//   if (depot && depot !== "") params.append("depot", depot);
//   if (search && search !== "") params.append("search", search);
  
//   apiUrl += "?" + params.toString();
  
//   return axios.get(apiUrl, {
//     headers: {
//       'X-Organization-ID': organizationId || ''
//     }
//   });
// };

export const fetchAllBatchesWithPagination = (
  page = 0,
  size = 10,
  startDate = null,
  endDate = null,
  state = null,
  depot = null,
  search = null,
  department = null
) => {
  const authUser = JSON.parse(localStorage.getItem("authUser"));
  const organizationId = authUser?.organizationId;

  let apiUrl = url.FETCH_ALL_BATCHES;
  const params = new URLSearchParams();

  params.append("page", page);
  params.append("size", size);

  if (startDate) params.append("startDate", startDate);
  if (endDate) params.append("endDate", endDate);
  if (state && state !== "") params.append("state", state);
  if (depot && depot !== "") params.append("depot", depot);
  if (search && search !== "") params.append("search", search);
  if (department && department !== "") params.append("department", department);

  apiUrl += "?" + params.toString();

  return axios.get(apiUrl, {
    headers: { 'X-Organization-ID': organizationId || '' }
  });
};

// ============================
// OTHER EXISTING FUNCTIONS
// ============================
export const createBatch = data => post(url.CREATE_BATCH, data);
export const updateBatch = data => put(url.UPDATE_BATCH, data);
export const deleteBatch = id => del(url.DELETE_BATCH + id);
export const fetchAllBatch = () => get(url.FETCH_ALL_BATCHES);
export const fetchAllBatchOfTrainer = () => get(url.FETCH_ALL_BATCHES_OF_TRAINER);
export const fetchSingleBatch = id => get(url.FETCH_SINGLE_BATCH + id);

export const addImages = data => post(url.ADD_IMAGES + data.id, data.images);
export const downloadImagesZipFile = id => get(url.DOWNLOAD_IMAGES_ZIP_FILE + id);
export const deleteImageFromS3 = image => del(url.DELETE_IMAGE_FROM_S3, { data: image });

// export const addCourseToBatch = (batchId, courseId) => post(url.ADD_COURSE_TO_BATCH + batchId + "/" + courseId);
// export const getAllCourseOfBatch = id => get(url.FETCH_ALL_COURSE_OF_BATCH + id);
// export const removeCourseFromBatch = (batchId, courseId) => del(url.REMOVE_COURSE_FROM_BATCH + batchId + "/" + courseId);

// export const addScormCourseToBatch = (batchId, courseId) => post(url.ADD_SCORM_COURSE_TO_BATCH + batchId + "/" + courseId);
// export const getAllScormCourseOfBatch = id => get(url.FETCH_ALL_SCORM_COURSE_OF_BATCH + id);
// export const removeScormCourseFromBatch = (batchId, courseId) => del(url.REMOVE_SCORM_COURSE_FROM_BATCH + batchId + "/" + courseId);




export const addCourseToBatch = ids => post(url.ADD_COURSE_TO_BATCH + ids);
export const getAllCourseOfBatch = id => get(url.FETCH_ALL_COURSE_OF_BATCH + id);
export const removeCourseFromBatch = ids => del(url.REMOVE_COURSE_FROM_BATCH + ids);

export const addScormCourseToBatch = ids => post(url.ADD_SCORM_COURSE_TO_BATCH + ids);
export const getAllScormCourseOfBatch = id => get(url.FETCH_ALL_SCORM_COURSE_OF_BATCH + id);
export const removeScormCourseFromBatch = ids => del(url.REMOVE_SCORM_COURSE_FROM_BATCH + ids);





// export const addStudentToBatch = (batchId, studentId) => post(url.ADD_STUDENT_TO_BATCH + batchId + "/" + studentId);
// export const removeStudentFromBatch = (batchId, studentId) => del(url.REMOVE_STUDENT_FROM_BATCH + batchId + "/" + studentId);
// export const getAllStudentOfBatch = id => get(url.FETCH_ALL_STUDENT_OF_BATCH + id);
// export const removeAllStudentsFromBatch = id => del(url.REMOVE_ALL_STUDENT_FROM_BATCH + id);

export const addStudentToBatch = ids => post(url.ADD_STUDENT_TO_BATCH + ids);
export const removeStudentFromBatch = ids => del(url.REMOVE_STUDENT_FROM_BATCH + ids);
export const getAllStudentOfBatch = id => get(url.FETCH_ALL_STUDENT_OF_BATCH + id);
export const removeAllStudentsFromBatch = id => del(url.REMOVE_ALL_STUDENT_FROM_BATCH + id);

// export const addTrainerToBatch = (batchId, trainerId) => post(url.ADD_TRAINER_TO_BATCH + batchId + "/" + trainerId);
// export const removeTrainerFromBatch = (batchId, trainerId) => del(url.REMOVE_TRAINER_FROM_BATCH + batchId + "/" + trainerId);
// export const getAllTrainerOfBatch = id => get(url.FETCH_ALL_TRAINER_OF_BATCH + id);
// export const removeAllTrainersFromBatch = id => del(url.REMOVE_ALL_TRAINER_FROM_BATCH + id);

// export const getAssessmentResultOfBatchStudent = (batchId, studentId) => get(url.GET_ASSESSMENT_RESULT_OF_BATCH_STUDENT + batchId + "/" + studentId);

export const addTrainerToBatch = ids => post(url.ADD_TRAINER_TO_BATCH + ids);
export const removeTrainerFromBatch = ids => del(url.REMOVE_TRAINER_FROM_BATCH + ids);
export const getAllTrainerOfBatch = id => get(url.FETCH_ALL_TRAINER_OF_BATCH + id);
export const getAssessmentResultOfBatchStudent = ids => get(url.GET_ASSESSMENT_RESULT_OF_BATCH_STUDENT + ids);
export const removeAllTrainersFromBatch = id => del(url.REMOVE_ALL_TRAINER_FROM_BATCH + id);
export const getExamResult = (batchId, studentId) => get(url.GET_EXAM_RESULT + batchId + "/" + studentId);

export const updateProgress = (moduleId, lessonIndex) => get(url.UPDATE_PROGRESS + moduleId + "/" + lessonIndex);
export const getStudentProgress = (studentId, moduleId) => get(url.GET_STUDENT_PROGRESS + studentId + "/" + moduleId);

export const studentAddedNotification = id => get(url.STUDENT_ADDED_NOTIFICATION + id);
export const trainingCompletionNotification = id => get(url.TRAINING_COMPLETION_NOTIFICATION + id);

export const createLiveClass = data => post(url.CREATE_LIVE_CLASS, data);
export const updateLiveClass = data => put(url.UPDATE_LIVE_CLASS, data);
export const deleteLiveClass = id => del(url.DELETE_LIVE_CLASS + id);

export const addMultipleStudentsToBatch = (batchId, studentIds, organizationId) => {
  const studentIdsParam = studentIds.join(',');
  const apiUrl = `${url.ADD_MULTIPLE_STUDENTS_TO_BATCH}${batchId}?studentIds=${studentIdsParam}`;
  
  const headers = {};
  if (organizationId) {
    headers['X-Organization-ID'] = organizationId;
  }
  
  return axios.get(apiUrl, { headers });
};